import React from "react";
import useLoaderStore from "../../store/loaderStore";
import { TopProgressBar, useDelayedLoading } from "../UI/loading";

/**
 * App-wide request indicator: a 2px bar fixed under the header. It used to be
 * a full-screen spinner overlay; list pages now show their own skeletons and
 * the bar hides while one of them is active.
 */
const GlobalLoader = () => {
  const active = useLoaderStore((s) => s.activeRequests > 0);
  const mutating = useLoaderStore((s) => s.mutatingRequests > 0);
  const scoped = useLoaderStore((s) => s.scopedLoaders > 0);
  const showBar = useDelayedLoading(active && !scoped);

  return (
    <>
      <TopProgressBar active={showBar} fixed />
      {mutating && (
        <div
          aria-hidden="true"
          className="fixed inset-0 cursor-progress"
          style={{ zIndex: 2147483000 }}
        />
      )}
    </>
  );
};

export default GlobalLoader;
